<template>
    <div id="search_page">
        <div id="main">
            <div class="main-wrap">
                <vertical-list-component ref="vertical" />
            </div>
        </div>
    </div>
</template>

<script>

    import verticalComponent from '../component/VerticalListComponent';

    import * as config from '../../js/config';
    import common from '../../js/common';
    import EventBus from '../../js/event_bus';

    export default {
        name: 'search_page',
        components: {
            'vertical-list-component': verticalComponent
        },
        data () {
            return {
                params: {}
            }
        },
        mounted(){
            this.$nextTick(function(){

                var getParams = common.getParams();
                if(typeof getParams != 'undefined'){
                    if(Object.keys(getParams).length !== 0){
                        this.params = getParams;
                        this.initApp();
                    }
                }

                EventBus.$on('search-data', (data)=>{
                    this.params = data;
                    this.initApp();
                });
                // 2021-01-14 코드수정 및 추가
                EventBus.$on('set_params_search', (data) => {
                data.scrollY = this.scrollY; // 스크롤 데이터

                common.setParams(data);
                EventBus.$emit('detail-data', data);
                this.$router.push('/detail');
            });
            })
        },
        methods: {
            initApp(){
                common.setLocationData((data) => {
                    data.type = config.REQ_SEARCH_STORE_LIST;
                    data.search_type = 'search';
                    // var getParam = common.getParams();
                    data.keyword = this.params.keyword;
                    this.$refs.vertical.initComponent(data);
                });
            },
        },
        beforeDestroy(){
            // 이벤트버스 사용 후 해제 시켜줄 것 그렇지 않으면 객체가 쌓이는 현상이 발생
            EventBus.$off('search-data');
            // 2021-01-14 코드수정 및 추가
            EventBus.$off('set_params_search');
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
   
</style>



// WEBPACK FOOTER //
// src/components/page/SearchPage.vue